import { styled } from '@clickcease/cc-client-components-lib'

export const CampaignSettingsTitleSectionContainer = styled('div', {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
})

export const BottomContainer = styled('div', {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',

  '& button': {
    marginLeft: 'auto',
  },
})

export const SuccessMessageContainer = styled('div', {
  fontSize: '$md',
  color: '$black',
  backgroundColor: '$successLighter',
  padding: '$2 $8',
  border: '1px solid #45a049',
  borderRadius: '4px',
  opacity: 1,
  transition: 'opacity 0.5s ease-in-out',
  display: 'inline-block',
  fontWeight: '500',
  variants: {
    hidden: {
      true: {
        opacity: 0,
      },
    },
  },
})
